import { useCurrentLocation, useOAuth, useCookie } from "#imports";
import { PUBLIC_ROUTE_NAMES } from "~/constants/routes";
import { getOAuthUser } from "~/utils/oauthUserStorage";
import { forgetLocationColors } from "~/composables/agenda/useLocationLegend";

export default defineNuxtRouteMiddleware(async (to) => {
  if (PUBLIC_ROUTE_NAMES.includes(String(to.name))) {
    return;
  }

  if (to.path === "/login") {
    const { checkAndCleanupStaleAuth } = await useOAuth();
    const wasCleanedUp = checkAndCleanupStaleAuth();
    if (!wasCleanedUp && getOAuthUser()) {
      return navigateTo("/");
    }
    return;
  }

  const { currentLocationId, forgetLocation } = useCurrentLocation();
  const { retrieveLocationToken, checkAndCleanupStaleAuth } = await useOAuth();

  const redirectCookie = useCookie("redirect_uri");

  const wasCleanedUp = checkAndCleanupStaleAuth();

  const user = getOAuthUser();
  if (!user || wasCleanedUp) {
    redirectCookie.value = to.fullPath;

    await forgetLocation();
    forgetLocationColors();

    if (to.path !== "/login") {
      return navigateTo("/login");
    }
  }

  if (redirectCookie.value !== undefined) {
    const redirectTo = redirectCookie.value;

    redirectCookie.value = null;

    if (to.path !== redirectTo) {
      return navigateTo(redirectTo);
    }
  }

  if (currentLocationId.value && to.query.ref === "invitation") {
    await retrieveLocationToken(currentLocationId.value);
  }
});
